import {
	designTokens,
	RiAlertFill,
	RiErrorWarningFill
} from "@itandi/itandi-bb-ui";
import { Chip } from "@itandi/itandi-bb-ui/Chip";
import { Flex } from "@itandi/itandi-bb-ui/Flex";
import { Label } from "@itandi/itandi-bb-ui/Label";
import dayjs from "dayjs";
import type { ReactNode } from "react";
import { formatDateWithWeekday } from "~/utils/DateUtil";

type Props = {
	todoDueDate: string | null;
};

export function TodoDueDateCell({ todoDueDate }: Props): ReactNode {
	if (todoDueDate === null) {
		return (
			<Label color="subtle" size="xs">
				未登録
			</Label>
		);
	}

	const dueDate = dayjs(todoDueDate);
	const today = dayjs();
	const isPast = dueDate.isBefore(today, "day");

	if (!isPast && !dueDate.isSame(today, "day")) {
		return formatDateWithWeekday(todoDueDate);
	}

	return (
		<Flex
			alignItems="start"
			direction="column"
			gap={designTokens["spacing/xxxs"]}
		>
			<Label color={isPast ? "danger" : "warning"}>
				{formatDateWithWeekday(todoDueDate) ?? ""}
			</Label>
			<Chip
				background={
					isPast
						? designTokens["color/chips/presentation/background/red"]
						: designTokens["color/chips/presentation/background/yellow"]
				}
				fontWeight="bold"
				Icon={isPast ? RiErrorWarningFill : RiAlertFill}
				iconColor={
					isPast
						? designTokens["color/chips/presentation/foreground/red"]
						: designTokens["color/chips/presentation/foreground/yellow"]
				}
				label={isPast ? "期限切れ" : "本日中期限"}
				textColor={
					isPast
						? designTokens["color/chips/presentation/foreground/red"]
						: designTokens["color/chips/presentation/foreground/yellow"]
				}
			/>
		</Flex>
	);
}
